{
	"admin-hub.ci-test.message-template-template-hello-world": "Hello {propA}. Is is a lovely {propB}",
	"ci-generation.email.body": "Il s'agit d'un message de test de l'environnement {env}.",
	"ci-generation.email.body.hello": "Salut {name},",
	"ci-generation.email.body.img.alt": "Ceci est le texte alternatif de l'image",
	"ci-generation.email.body.regards": "Équipe Post Office",
	"ci-generation.email.body.signoff": "Salutations,",
	"ci-generation.email.subject": "Message de test du bureau de poste de {env}",
	"ci-generation.email.unsubscribe.text": "Se désabonner",
	"post-office.test-message.email.subject": "Message de test du bureau de poste de {env}.",
	"post-office.test-message-microsoft-teams.sample-hello-message": "Bonjour, ceci est un message de test de Post Office: {text}",
	"post-office.test-slack-notification.sample-hello-message": "Bonjour, *Ceci est un test de notification de post office*",
	"post-office.test-messages.test-message-mobile-push.greeting.no-translate": "Bonjour, il s'agit d'un test de notification push mobile pour la Poste.",
	"test-messages.email.body.regards": "Équipe Post Office",
	"test-messages.test-message.email.body": "Il s'agit d'un message de test de l'environnement {env}. {additionalBody}",
	"test-messages.test-message.email.body.hello": "Salut Atlassian,",
	"test-messages.test-message.email.body.img.alt": "c'est l'alt pour le modèle de message test-message-e-mail",
	"test-messages.test-message.email.body.signoff": "Salutations,",
	"test-messages.test-message.email.unsubscribe.text": "Se désabonner"
}
